import { Provider } from 'react-redux'
import { Store } from './Flux/index.js'
import { useEffect } from 'react'
import { Environment } from './environment.js'
import { AppWithStoreWrapper } from './AppWithStoreWrapper.js'

function App() {
  useEffect(() => {
    console.log('Running in Sentry environment', Environment.SENTRY_ENVIRONMENT)
    console.log('Running on Sentry release version', Environment.SENTRY_RELEASE_VERSION)
  }, [])

  return (
    <Provider store={Store}>
      <AppWithStoreWrapper />
    </Provider>
  )
}

export default App
